import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useBackdrop } from '../../common/components/backDrop_context.component';
import { notify } from '../../common/functions/react-toastify.function';
import { deleteRingGroup } from './functions/delete_ring_group.function';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: '5px',
  p: 4,
};

export default function DeleteRingModal({ open, onClose, selectedRing, onDeleteSuccess }) {
  const { showBackdrop, hideBackdrop } = useBackdrop();

  const handleDeleteRing = async () => {
    if (!selectedRing) {
      return;
    }

    showBackdrop();
    try {
      const resp = await deleteRingGroup(selectedRing.id);

      // First refresh the list, then show success message
      if (onDeleteSuccess) {
        await onDeleteSuccess();
      }

      hideBackdrop();
      onClose();

      // Show success message after the list is refreshed
      notify('success', resp?.message || 'Ring deleted successfully');
    } catch (error) {
      hideBackdrop();
      notify('error', 'Something went wrong');
      onClose();
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              width: 500,
              height: 136,
              background: 'white',
              borderRadius: 12,
              flexDirection: 'column',
              justifyContent: 'flex-start',
              alignItems: 'center',
              display: 'inline-flex',
            }}
          >
            <div style={{ width: '100%' }}>
              <div
                data-svg-wrapper
                style={{ position: 'relative', cursor: 'pointer' }}
                onClick={handleClose}
              >
                <svg
                  width="24"
                  style={{ float: 'right' }}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5859 12.0001L2.79297 4.20718L4.20718 2.79297L12.0001 10.5858L19.793 2.79297L21.2072 4.20718L13.4143 12.0001L21.2072 19.7929L19.793 21.2072L12.0001 13.4143L4.20718 21.2072L2.79297 19.7929L10.5859 12.0001Z"
                    fill="#BD1D23"
                  />
                </svg>
              </div>
            </div>
            <div
              style={{
                width: 486,
                textAlign: 'center',
                color: 'black',
                fontSize: 20,
                fontFamily: 'Poppins',
                fontWeight: '500',
                wordWrap: 'break-word',
              }}
            >
              Are you sure you want to delete{' '}
              <span
                style={{
                  color: '#FF6B35',
                  fontWeight: '700',
                  fontSize: 22,
                }}
              >
                {selectedRing?.name}
              </span>
              ?{' '}
            </div>
            <div
              style={{
                width: 85,
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 15,
                paddingBottom: 15,
                background: '#BD1D23',
                marginTop: '10%',
                boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                borderRadius: 4,
                overflow: 'hidden',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'inline-flex',
              }}
            >
              <div
                onClick={handleDeleteRing}
                style={{
                  paddingLeft: 8,
                  paddingRight: 8,
                  cursor: 'pointer',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 10,
                  display: 'flex',
                }}
              >
                <div
                  style={{
                    color: 'white',
                    fontSize: 14,
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    wordWrap: 'break-word',
                  }}
                >
                  Delete
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
